// extracted by mini-css-extract-plugin
export default {"statsContainer":"statistic_statsContainer__DUJyS","statItem":"statistic_statItem__OdbHm"};